var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { formatReportModuleParams, useReport } from '@tencent/dz-report';
import { DISEASETABS } from './DiseaseTabs';
export var useReportService = function (_a) {
    var content = _a.content, recommendMode = _a.recommendMode, nerMode = _a.nerMode, currentTab = _a.currentTab;
    var report = useReport();
    var getDiseaseEleContent = function (current) {
        var _a;
        var activeText = (_a = DISEASETABS.find(function (val) { return val.content === current; })) === null || _a === void 0 ? void 0 : _a.name;
        var tabText = DISEASETABS.map(function (val) { return val.name; }).join(',');
        return content.name + "^" + activeText + "^" + tabText;
    };
    var cardParams = {
        module_id: content.id,
        module_value: content.name,
        module_type: 'card_disease',
        module_chinese_type: '疾病卡片',
        element_id: content.id,
        element_type: 'card_disease',
        element_chinese_type: '疾病卡片',
        element_content: getDiseaseEleContent(currentTab),
        recommend_mode: recommendMode,
        ner_mode: nerMode,
    };
    var modalModuleParams = {
        module_id: content.id,
        module_value: content.name,
        module_type: 'card_disease_detail_popup',
        module_chinese_type: '疾病卡片_详情弹窗',
    };
    var cardReportModuleParams = formatReportModuleParams(cardParams);
    React.useEffect(function () {
        report.exposure(cardParams);
    }, []);
    var diseaseClick = function () {
        report.click(cardParams);
    };
    var diseaseModalExposure = function (currentTab) {
        report.exposure(__assign(__assign({}, modalModuleParams), { element_id: content.id, element_type: 'card_disease_detail_popup', element_chinese_type: '疾病卡片_详情弹窗', element_content: getDiseaseEleContent(currentTab) }));
    };
    var diseaseTabClickReport = function (type, index, name) {
        switch (type) {
            case 'card':
                report.click(__assign(__assign({}, cardReportModuleParams.module), { element_id: index, element_type: 'tab', element_chinese_type: 'tab', element_content: name }));
                break;
            case 'modal':
                report.click(__assign(__assign({}, modalModuleParams), { element_id: index, element_type: 'tab', element_chinese_type: 'tab', element_content: name }));
                break;
            default:
                break;
        }
    };
    return {
        cardReportModuleParams: cardReportModuleParams,
        diseaseModalExposure: diseaseModalExposure,
        diseaseClick: diseaseClick,
        getDiseaseEleContent: getDiseaseEleContent,
        diseaseTabClickReport: diseaseTabClickReport,
    };
};
